import axios from 'axios'

let vhukit = axios.create({
  baseURL: 'http://localhost:3001',
  timeout: 10000
})

export const setClientToken = token => {
  vhukit.interceptors.request.use(function(config) {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
};

export default vhukit


// WEBPACK FOOTER //
// ./src/actions/vhukit.js